import React, {useState, lazy, useEffect} from 'react';
import * as SharedAcross from './Common/SharedAcross';
import DisplayPage from './DisplayPage';
import BottomRows from './BottomRows';
import * as RowsFns from './RowsFns';
import HTMLView from './HTMLView';

const importView = chartName =>
  lazy(() =>
    import(`./${chartName}`)
      .catch(() => import(`./NullChart`))
  );

function App(props) {

  var left = props.left;
  var firstLineTitle = props.firstLineTitle;
  var addToExtraScreen = props.addToExtraScreen;

  var setHandTarget = props.setHandTarget;
  var handTarget = props.handTarget;
  var isRight = props.isRight;
  var boldTarget = props.boldTarget;
  var titleOverride = props.titleOverride;

  var startPoint = props.startPoint;
  var endPoint = props.endPoint;

  var options = left.v[2].v;
  var intentTree = left.v[1].v;
  var defaultText = left.v[3].v;
  if (left.v[3].t === "number"){
    defaultText = defaultText.toString();
  }

  var clickLogIn = props.clickLogIn;
  var clickLogOut = props.clickLogOut;
  var userSubdomainID = props.userSubdomainID;
  var highlightedColor = "#FFB900";
  var setExtraScreenSet = props.setExtraScreenSet;

  const [selectionText, setSelectionText] = useState(defaultText);


  useEffect(() =>{
    setSelectionText(defaultText)
  }, [defaultText, intentTree.length])

  var cover = props.cover;

  const [MobilePiece, setMobilePiece] = useState(null);

  if (!MobilePiece){
    if (cover.t === "atom"){
      const Chart1 = importView(cover.v);
      setMobilePiece(Chart1);      
    }
  }

  useEffect(() => {
    if (cover.t === "atom"){
      const Chart1 = importView(cover.v);
      setMobilePiece(Chart1);      
    }
  }, [cover]);

  var displayPiece = props.display;

  var adminAction = props.adminAction;
  var setIntentStuff = props.setIntentStuff;
  var sessionHistoryID = props.sessionHistoryID;
  var width = props.width;
  var height = props.height;
  var updateUserInfo = props.updateUserInfo;
  var topRow = props.topRow;
  var subdomainID = props.subdomainID;
  var isSubmitting = props.isSubmitting;
  var showAllExtra = props.showAllExtra;

  var setPictures = props.setPictures;
  var setPicturePreview = props.setPicturePreview;
  var pictures = props.pictures;
  var picturePreview = props.picturePreview;

  var levels = props.levels;

  var isSubmittingWhat = props.isSubmittingWhat;
  var setIsSubmittingWhat = props.setIsSubmittingWhat;

  function onDrop(file, picture){
    setPictures(file);
    setPicturePreview(picture);
  };

  var topRow2 = [];

  if (intentTree.length > 1){
    function clickClearQuestion(e){
      adminAction("clearQuestion", {sessionHistoryID}, setIntentStuff)
    }      
    topRow2 = [{f:clickClearQuestion, i:"/client_pictures/home_grey_128.png",t:"Home"},{f:getAPosition(intentTree.length - 2),i:"/client_pictures/back_grey_128.png",t:"Back"}];
  }        

  function getAPosition(pos1){
    return function(e){
      var levels1 = SharedAcross.convertLevels(levels);
      adminAction("submitLocation", {action:"getPosition", sessionHistoryID, pos:pos1, levels:levels1}, setIntentStuff);
    }
  }


  function actuallySubmitLocation(selectedIntentID, selectedIntentText, selectedPostPart){

    adminAction("submitLocation", {action:"clickButton", levels:SharedAcross.convertLevels(levels), sessionHistoryID, selectedIntentText, selectedIntentID, selectedPostPart}, setIntentStuff, pictures);
    setSelectionText("");
    setPictures([]);
    setPicturePreview([]);
  }


  function submitLocation(aCell){
    return function(e){
      if (aCell.f){
        aCell.f();
      }else{
        var selectedIntentText = aCell.v[1].v;
        var selectedIntentID = aCell.v[0].v;
        var selectedPostPart = 0;
        if (aCell.v.length < 3){
          var commaLoc = selectedIntentID.indexOf(",");
          if (commaLoc){
            if (commaLoc > 0){
              selectedPostPart = selectedIntentID.substr(commaLoc+1);
              var first = selectedIntentID.substr(0, commaLoc);
              selectedIntentID = +first;
            }            
          }
        }else{
          selectedIntentID = +aCell.v[0].v;
          selectedPostPart = aCell.v[2].v;
        }
        setIsSubmittingWhat({selectedIntentID, selectedPostPart});
        actuallySubmitLocation(selectedIntentID, selectedIntentText, selectedPostPart);        
      }
    }
  }

  function clickSubmitAnswer(questionType){
    return function(e){
      submitAnswer(questionType);
    }
  }
  function submitAnswer(questionType){
    if (questionType === "9" || questionType === "18" || questionType === "16" || questionType === "14" || questionType === "28" || questionType === "29"){
      actuallySubmitLocation(+questionType, selectionText, selectionText);
    }else if (questionType === "27"){
      if (pictures.length === 0){
        window.alert("At least one photo is required");
      }else{
        actuallySubmitLocation(+questionType, selectionText, selectionText);
      }     
    }else if (questionType === "12"){
      var regex = /^([+-]?[1-9]\d*|0)$/
      if (selectionText.match(regex)){
        actuallySubmitLocation(+questionType, selectionText, +selectionText);
      }else{
        window.alert("Sorry, only integers are allowed");
      }
    }else if (questionType === "30"){ // variable anme
      var selectionTextA = selectionText.trim();
      if (selectionTextA.length === 0){
        window.alert("Names cannot be empty");
        return;
      }else if (selectionTextA.indexOf(" ") > -1){
        window.alert("Spaces not allowed");
        return;
      }

        actuallySubmitLocation(+questionType, selectionTextA, selectionTextA);
    }else if (questionType === "15"){
      var regex2 = /^[+-]?((\d+(\.\d*)?)|(\.\d+))$/
      if (selectionText.match(regex2)){
        actuallySubmitLocation(+questionType, selectionText, selectionText);
      }else{
        window.alert("Sorry, only numbers are allowed");
      }
    }else{
      var  selectionTextTrim = selectionText.trim().toLowerCase();
      var optionsFiltered1 = options.filter((anOption, index)=>{
        return anOption.v[1].v.toLowerCase().indexOf(selectionTextTrim) > -1 ;
      })
      if (optionsFiltered1.length === 1){
        submitLocation(optionsFiltered1[0])();
      }else{
        if (selectionTextTrim.length > 0){
          var exact = optionsFiltered1.filter((anOption, index)=>{
            return anOption.v[1].v.toLowerCase() === selectionTextTrim;
          })
          if (exact.length === 1){
            submitLocation(exact[0])();
          }
        }            
      }
    }
  }

  var rightRows = [];

  function onMouseEnter(zeroIfLastLine, tgt){
    return function(e){
      if (isRight){
        if (zeroIfLastLine === 1){
          setHandTarget(tgt);
        }        
      }
    }
  }

  function onMouseLeave(e){
    setHandTarget(-1);
  }



  var gotAskToLogIn = false;
  // for (var index = 0; index < intentTree.length; index++){

  for (var index = startPoint; index <= endPoint; index++){
    var tree = intentTree[index];
    var questionSet = tree.v[0];
    var thisPosition = +index;

    var questionText = questionSet.v[2].v;
    
    var extraPiece = questionSet.v[4];
    var titleStyle = {};
    if (index === intentTree.length - 1){
      if (isRight){
        if (handTarget === -2){
          titleStyle.backgroundColor = highlightedColor;
        }
      }
    }

    var className;
    if (isRight && index === intentTree.length - 1){
      className = "treeLine";
    }

    if (index < intentTree.length - 1){
      if (cover){
        rightRows.push(<tr key={"q" + thisPosition} ><td style={titleStyle} className={className} onMouseEnter={onMouseEnter(intentTree.length - index, -2)} onMouseLeave={onMouseLeave}><b>{questionText}</b></td></tr>)      
      }

    }
//
    if (extraPiece.t === "tuple"){
      var dispType = extraPiece.v[0].v;
      if (showAllExtra || (dispType !== "questionList" && dispType !== "dispTree" )){
        var rowStyle = {padding:"5px",overflowX:"auto",width};
        if (handTarget === -3 && index === intentTree.length - 1){
          rowStyle.backgroundColor = highlightedColor;
        }
//        
        var interactionPiece = <DisplayPage isSubmittingWhat={isSubmittingWhat} setIsSubmittingWhat={setIsSubmittingWhat} extraPiece={extraPiece} display={displayPiece} height={height} width={width} adminAction={adminAction} updateUserInfo={updateUserInfo} subdomainID={subdomainID} setIntentStuff={setIntentStuff} sessionHistoryID={sessionHistoryID} pos={index} levels={levels} isSubmitting={isSubmitting} setHandTarget={setHandTarget} handTarget={handTarget} addToExtraScreen={addToExtraScreen} boldTarget={""} setExtraScreenSet={setExtraScreenSet} />        
          rightRows.push(<tr key={"i" + thisPosition} ><td><div style={rowStyle} onMouseEnter={onMouseEnter(intentTree.length - index, -3)} onMouseLeave={onMouseLeave}>
                {interactionPiece}
                </div>
              </td></tr>)          
//
      }else if (!showAllExtra && dispType === "dispTree"){
        var interactionPiece1 = <div style={{padding:"10px",backgroundColor:"#FFFFFF",width:"100%",marginTop:"5px",marginBottom:"10px"}}>Select Options from Right Side Screen</div>
//
        if (cover){
          rightRows.push(<tr key={"i" + thisPosition} ><td>
                {interactionPiece1}
              </td></tr>)          
        }

      }

      if (dispType === "logIn"){
        gotAskToLogIn = true;
      }
    }else if (handTarget === -3 && isRight && index === endPoint){
      if (cover){
        rightRows.push(<tr key={"i" + thisPosition} style={{backgroundColor:highlightedColor}} ><td style={{textAlign:"center"}}><div style={{padding:"5px"}}>[Illustration]</div></td></tr>)
      }
    }
//
    var firstLineTitleUsed = "";
    if (index === 0){
      firstLineTitleUsed = firstLineTitle;
    }
    
    var ansPiece = RowsFns.ansPieceFn(tree, setSelectionText, submitAnswer, props, onDrop, options, selectionText, thisPosition, getAPosition, width, topRow2, submitLocation, isSubmittingWhat, isSubmitting, clickSubmitAnswer, firstLineTitleUsed, setHandTarget, handTarget, isRight, boldTarget, defaultText, picturePreview, setPicturePreview, setPictures, titleOverride);
      rightRows.push(ansPiece);
  }
  
  if (cover){


    var display;
    if (displayPiece){
      var lastIntentTree = intentTree[intentTree.length - 1];
      var anAnswer = lastIntentTree.v[1].v;
      var answerID = anAnswer[0].v;

      if (displayPiece.t === "tuple"){
        var dispType2 = displayPiece.v[0].v;
        if (dispType2 === "logIn"){
          gotAskToLogIn = true;
        }

      }
   
      if (answerID !== 0){

        var displayStyle = {padding:"5px"};
        if (handTarget === -4){
          displayStyle.backgroundColor = highlightedColor;
        }

        display = <div style={displayStyle} onMouseEnter={onMouseEnter(1, -4)} onMouseLeave={onMouseLeave} >
                     <DisplayPage  isSubmittingWhat={isSubmittingWhat} setIsSubmittingWhat={setIsSubmittingWhat} extraPiece={displayPiece} display={false} height={height} width={width} adminAction={adminAction} updateUserInfo={updateUserInfo} subdomainID={subdomainID} pos={-1} setIntentStuff={setIntentStuff} sessionHistoryID={sessionHistoryID}  isSubmitting={isSubmitting}  setHandTarget={setHandTarget} handTarget={handTarget} addToExtraScreen={addToExtraScreen} boldTarget={""} setExtraScreenSet={setExtraScreenSet}/>
                  </div>
//
      }
    }



    var bottomPiece;

    if (!gotAskToLogIn){
      if (userSubdomainID === -1){
        topRow2.push({f:clickLogIn, t:"Log In"})
      }else{
        topRow2.push({f:clickLogOut, i:"/client_pictures/logout_grey_icon_128.png",t:"Log Out"})
      }      
    }

    var topRowNet = topRow.concat(topRow2);

    if (topRowNet){
      bottomPiece = <BottomRows bottomRow={topRowNet} width={width}/>
    }

    var showPiece = <div width="100%">
                {bottomPiece}
                <table width="100%"  style={{borderCollapse:"collapse", borderSpacing:"0px"}}><tbody>
                  {rightRows}
                </tbody></table>
                {display}
              </div>

  //

    if (cover.t === "atom"){
      return (<React.Suspense fallback="Loading..."><MobilePiece height={height} width={width} showPiece={showPiece}/></React.Suspense>)
//
    }else{
      return <HTMLView html={cover} height={height} width={width} showPiece={showPiece}/>
    }
//
  }else{

    return <table style={{borderCollapse:"collapse", borderSpacing:"0px",width}}><tbody>
                  {rightRows}
                </tbody></table>
  }

//
}

export default App;
